export default __webpack_public_path__ + "static/media/31.5a8898ab.png";